import { atom } from 'jotai'

export type DeliveryPharmacyType = {
  address: string
  fax: string
  name: string
  tel: string
}

export const isClickEditButtonAtom = atom<boolean>(false)
export const isKeydownFeeAtom = atom<boolean>(false)
export const isEditFeeScreenAtom = atom<boolean>(false)
export const deliveryPharmacyAtom = atom<DeliveryPharmacyType>({
  address: '',
  fax: '',
  name: '',
  tel: '',
})
